module.exports = __webpack_public_path__ + "static/media/heartCondition.15a107dc.mp3";